import Image from 'next/image';
import { NavbarStyle } from '../../../styles/components/common/layout';

export interface INavBarDropdownProps {
  id: string;
  label: string;
  items?: { label: string; path: string }[];
  groups?: {
    title: string;
    path?: string;
    items: { label: string; path: string }[];
  }[];
  onToggle?: (event: React.SyntheticEvent<HTMLDetailsElement>) => void;
}

const NavBarDropdown = (props: INavBarDropdownProps) => {
  const handleDropDownToggle = (
    event: React.SyntheticEvent<HTMLDetailsElement>
  ) => {
    if (props.onToggle) {
      props.onToggle(event);
    }
  };

  return (
    <details
      id={props.id}
      className={NavbarStyle['dropdown']}
      onToggle={handleDropDownToggle}>
      <summary
        className={`${NavbarStyle['dropdown-summary']} ${NavbarStyle['navbar-link']}`}>
        <div className={NavbarStyle['dropdown-button']}>
          <span>{props.label}</span>
          <Image
            quality={90}
            className={NavbarStyle['dropdown-arrow']}
            priority
            src="/assets/images/icons/NavBarItemChevronIcon.svg"
            alt={props.label}
            width={12}
            height={8}
          />
        </div>
      </summary>
      <div
        className={`${NavbarStyle['dropdown-content']} ${
          props.groups ? NavbarStyle['dropdown-content-2col'] : ''
        }`}>
        {props.groups &&
          props.groups.map((group, index) => (
            <div key={index}>
              {group.path && (
                <a
                  href={group.path}
                  className={NavbarStyle['dropdown-content-title']}>
                  {group.title}
                </a>
              )}
              {!group.path && (
                <p className={NavbarStyle['dropdown-content-title']}>
                  {group.title}
                </p>
              )}
              <ul>
                {group.items.map((value, index) => {
                  return (
                    <li key={index}>
                      <a href={value.path}>{value.label}</a>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}

        {props.items && props.items.length > 0 && (
          <ul>
            {props.items.map((value, index) => {
              return (
                <li key={index}>
                  <a href={value.path}>{value.label}</a>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </details>
  );
};

export default NavBarDropdown;
